import { render } from "./payment.vue?vue&type=template&id=49747f0b&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=49747f0b&lang=scss&scoped=true"
import "./payment.vue?vue&type=style&index=1&id=49747f0b&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49747f0b"]])

export default __exports__